// This is a manifest file that'll be compiled into application.js, which will include all the files
// listed below.
//
// Any JavaScript/Coffee file within this directory, lib/assets/javascripts, vendor/assets/javascripts,
// or any plugin's vendor/assets/javascripts directory can be referenced here using a relative path.
//
// It's not advisable to add code directly here, but if you do, it'll appear at the bottom of the
// compiled file.
//
// Read Sprockets README (https://github.com/rails/sprockets#sprockets-directives) for details
// about supported directives.
//
import "./import_jquery";

import "jquery-ujs";
import "jquery-jpostal-ja";
import "jquery.cookie";
import "jquery-ui/dist/jquery-ui";
import "jquery-ui-touch-punch";
import "./parent/application_init";
import "./parent/slidebars";
import "./parent/common";
import "./parent/sign_up";
import "./parent/address_form_change";
import "./parent/slide_bar";
